import { LoanappService } from './../../services/loanapp.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, tap, filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { ExportService } from 'app/services/export.service';
import { numberWithCommaService } from 'app/services/numberWithComma.service';

declare var $: any;

@Component({
  selector: 'app-allloans',
  templateUrl: './allloans.component.html',
  styleUrls: ['./allloans.component.css'],
})
export class AllloansComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  loanAppsLoaded: Boolean = false;
  page = 1;
  public daterange: any = {};
  public options: any = {
    locale: { format: 'YYYY-MM-DD' },
    alwaysShowCalendars: false,
  };
  showClearFilterBtn: Boolean = false;

  dateRange: any = 'Select Date';
  public errMessage: string = '';

  dateQueryParam: any = null;
  totalRec: number;

  searchForm = new FormGroup({
    nameOrId: new FormControl(''),
    pageLimit: new FormControl(10),
  });

  fileHeaders = [
    'Application ID',
    'WHR Number',
    'Name of Borrower',
    'Loan Application Date',
    'Commodity Type',
    'Net Quantity',
    'Unit Price',
    'Value of Stock',
    'Approved Loan Amount',
    'Approved Date',
    'Repayment Scheduled',
    'Loan Application Status',
    'CMA Appointment Status',
  ];

  runningQuery: Subscription;

  constructor(
    private lservice: LoanappService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private exportService: ExportService,
    private numberFormat: numberWithCommaService
  ) { }

  ngOnInit() {
    this.getProfile();

    this.runningQuery = this.getLoanApplications().subscribe((data) =>
      this.gotLoanApplications(data)
    );

    this.searchForm
      .get('nameOrId')
      .valueChanges.pipe(
        debounceTime(100),
        tap(() => {
          this.p = 1;
        })
      )
      .subscribe(() => {
        this.runningQuery = this.getLoanApplications().subscribe((data) => {
          this.gotLoanApplications(data);
        });
      });

    this.searchForm
      .get('pageLimit')
      .valueChanges.pipe(
        debounceTime(100),
        filter((value) => value > 0),
        tap((value) => {
          this.p = 1;
          this.itemsPerPage = value;
        })
      )
      .subscribe(() => {
        this.runningQuery = this.getLoanApplications().subscribe((data) => {
          this.gotLoanApplications(data);
        });
      });
  }

  filterQueryParams(createFor = 'listing') {
    const params: any = {};

    if (createFor === 'listing') {
      params.page = String(this.p);
      params.limit = String(this.itemsPerPage);
    }

    const searchFor = this.searchForm.get('nameOrId').value;

    if (searchFor) params.searchFor = searchFor;

    if (this.dateQueryParam) {
      params.startDate = this.dateQueryParam.startDate;
      params.endDate = this.dateQueryParam.endDate;
    }

    return params;
  }

  getLoanApplications(getFor = 'listing') {
    this.loanAppsLoaded = false;
    const params = this.filterQueryParams(getFor);

    if (this.runningQuery) this.runningQuery.unsubscribe();

    return this.lservice.getAllLoansApplied(params);
  }

  gotLoanApplications(data) {
    this.loanAppsLoaded = true;
    this.dataRec = true;
    if (data['success']) {
      this.lApplications = data['data'];
      this.totalRec = data['appCount'];
      this.dataToShow = data['data'];
      for (let i = 0; i < this.dataToShow.length; i++) {
        this.dataToShow[i]['tprice'] =
          this.dataToShow[i]['depositQty'] *
          (this.dataToShow[i]['depositApp']
            ? this.dataToShow[i]['depositApp']['perUnitValue']
            : 1);
        if (
          !this.isInArray(
            this.lApplications[i]['warehouseName'],
            this.filterWnameArr
          )
        ) {
          this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
        }
      }
    } else {
      this.toastr.error('Something went wrong, please try again.');
      this.loanAppsLoaded = true;
    }
  }

  getProfile() {
    this.loanAppsLoaded = false;

    this.auth.getProfile().subscribe(
      (profile) => {
        this.user = profile['user'];
        if (this.user['profileCompleted'] == 'false') {
          this.router.navigateByUrl('/completeprofile');
        } else {
          if (this.user['accountStatus'] == 'inactive') {
            this.router.navigateByUrl('/completeprofile');
          } else {
            console.log('All done');
          }
        }
      },
      (err) => {
        this.router.navigateByUrl('/login');
        console.log(err);
        this.toastr.error('Something went wrong. Please try again.');
        this.loanAppsLoaded = true;

        return false;
      }
    );
  }

  public chosenDate(value: any) {
    this.showClearFilterBtn = true;
    this.dateQueryParam = value;
    this.p = 1;

    this.runningQuery = this.getLoanApplications().subscribe((data) =>
      this.gotLoanApplications(data)
    );

    // let sDate = new Date(value.startDate);
    // let eDate = new Date(value.endDate);
    // this.findApplicationsByDate(sDate, eDate);
  }

  findApplicationsByDate(sDate, eDate) {
    this.lservice.filterByTimestamp(sDate, eDate).subscribe(
      (data) => {
        if (data['success']) {
          this.dataToShow = data['data'];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  clearFilters() {
    // Unset date query
    this.dateQueryParam = null;
    this.showClearFilterBtn = false;
    this.p = 1;

    this.runningQuery = this.getLoanApplications().subscribe((data) =>
      this.gotLoanApplications(data)
    );
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  toggleMenu() {
    $('#sidebar').toggleClass('active');
    $('#rotateN').toggleClass('rotate180');
    $('#sidebarCollapse').toggleClass('m10Sty');
    let elem = document.getElementById('asdsadada');
    if (elem.classList.contains('disnone')) {
      setTimeout(() => {
        $('#asdsadada').toggleClass('disnone');
      }, 200);
    } else {
      $('#asdsadada').toggleClass('disnone');
    }
  }

  writeToPDF(dataToWrite) {
    const doc = new jsPDF('landscape');
    const rows = this.fileWriteArray(dataToWrite, 'pdf').map((data) =>
      this.fileHeaders.map((h) => data[h])
    );

    doc.setFontSize(9);
    doc.autoTable(this.fileHeaders, rows);
    doc.save('Loan_Applications' + new Date().toDateString() + '.pdf');
  }

  downloadPDF() {
    this.runningQuery = this.getLoanApplications('download').subscribe(
      (response) => {
        const data = response['data'];
        this.loanAppsLoaded = true;
        this.writeToPDF(data);
      }
    );
  }

  getDate(d) {
    let f = new Date(d);
    let dateString = f.toString().slice(0, 15);
    return dateString;
  }

  print(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    location.reload();
  }

  formatDateForFile(date, fileType) {
    if (fileType === 'csv') {
      return new Date(date);
    }

    return date;
  }

  fileWriteArray(dataToWrite, fileType) {
    return dataToWrite.map((data) => ({
      'Application ID': data._id,
      'WHR Number':
        data.depositApp && data.depositApp.mswcReceiptId
          ? data.depositApp.mswcReceiptId
          : data.blockchainReceiptId,
      'Name of Borrower': data.applicantName,
      'Loan Application Date': this.formatDateForFile(
        moment(data.timestamp).format('YYYY-MM-DD'),
        fileType
      ),
      'Warehouse Name': data.warehouseName,
      'Commodity Type':
        data.commodityId && data.commodityId.name
          ? data.commodityId.name
          : data.commodityName,
      'Net Quantity': `${data.depositQty} ${data.depositUom}`,
      'Unit Price': data.depositApp ? Number(data.depositApp.perUnitValue) : 'nil',
      'Value of Stock': data.totalReceiptValue,
      'Approved Loan Amount': data.approved ? data.approved.loanAmount : 'nil',
      'Approved Date': data.approved
        ? this.formatDateForFile(
          moment(data.approved.timestamp).format('YYYY-MM-DD'),
          fileType
        )
        : 'nil',
      'Repayment Scheduled': data.approved
        ? this.formatDateForFile(
          moment(data.approved.repaymentSchedule).format('YYYY-MM-DD'),
          fileType
        )
        : 'nil',
      'Loan Application Status': data.applicationStatus,
      'CMA Appointment Status': data.cmaAppointmentstatus,
      'Lien Marked': data.applicationStatus === 'approved' ? 'Yes' : 'No',
      'Repayment': data.repaymentAmount
    }));
  }

  writeToCSV(dataToWrite) {
    const downArr = this.fileWriteArray(dataToWrite, 'csv');

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: this.fileHeaders,
      showTitle: false,
      title: 'name',
      useBom: false,
      removeNewLines: true,
      noDownload: false,
    };

    this.exportService.excel(
      Object.keys(downArr.length ? downArr[0] : []),
      downArr,
      `Loan_Applications_All-${new Date().toDateString()}`
    );

    // new AngularCsv(
    //   downArr,
    //   'Loan_Applications-' + new Date().toDateString(),
    //   options
    // );
  }

  downloadCSV() {
    this.runningQuery = this.getLoanApplications('download').subscribe(
      (response) => {
        const data = response['data'];
        this.loanAppsLoaded = true;
        this.writeToCSV(data);
      }
    );
  }

  rowclick(value) {
    this.appObj = value;

    window.location.href =
      '/loanapplicationdetails?id=' +
      value['_id'] +
      '&p=dbloans' +
      '&uId=' +
      value['user']['_id'] +
      '&ref=allloans';
  }

  onSearchChange(searchValue: string) {
    if (searchValue !== '') {
      this.dataToShow = this.filterItems(searchValue);
    } else {
      this.dataToShow = this.lApplications;
    }
  }

  filterItems(searchTerm) {
    return this.lApplications.filter((item) =>
      Object.keys(item).some(
        (k) =>
          item[k] != null &&
          item[k].toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }

  onChangeWname(wname) {
    if (wname !== '') {
      this.dataToShow = this.filterWname(wname);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterWname(searchTerm) {
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].warehouseName.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }

  onChangeStatus(status) {
    if (status !== '') {
      this.dataToShow = this.filterStatus(status);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterStatus(searchTerm) {
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].applicationStatus.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }
  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  hSort(v) {
    this.dataToShow = this.dataToShow.sort(function (a, b) {
      if (a.totalReceiptValue < b.totalReceiptValue) return -1;
      if (a.totalReceiptValue > b.totalReceiptValue) return 1;
      return 0;
    });
  }

  dateSort() {
    this.dataToShow = this.dataToShow.sort(function (a, b) {
      if (a.timestamp < b.timestamp) return -1;
      if (a.timestamp > b.timestamp) return 1;
      return 0;
    });
  }

  getNewPages(page) {
    this.p = page;
    this.runningQuery = this.getLoanApplications().subscribe((data) =>
      this.gotLoanApplications(data)
    );
  }
}
